import generateSinglePicker from './generateSinglePicker';

type PickerComponent = React.ComponentType<any> & {
    WeekPicker?: React.ComponentType<any>;
    MonthPicker?: React.ComponentType<any>;
    YearPicker?: React.ComponentType<any>;
    TimePicker?: React.ComponentType<any>;
    QuarterPicker?: React.ComponentType<any>;
};

export default function generatePicker<TDate = any>(
    generateConfig: any
): PickerComponent {
    const {
        DatePicker,
        WeekPicker,
        MonthPicker,
        YearPicker,
        TimePicker,
        QuarterPicker,
    } = generateSinglePicker(generateConfig);

    const MergedDatePicker: PickerComponent = DatePicker;

    MergedDatePicker.WeekPicker = WeekPicker;
    MergedDatePicker.MonthPicker = MonthPicker;
    MergedDatePicker.YearPicker = YearPicker;
    MergedDatePicker.TimePicker = TimePicker;
    MergedDatePicker.QuarterPicker = QuarterPicker;

    return MergedDatePicker;
}